export const THREAD_ID_PARAM = "thread_id";
export const DUCK_FULLSCREEN_PARAM = "duckFullscreen";

export const DEFAULT_CHAT_BOTTOM_SCROLL_PADDING = 30;

// gpt-4.1 context window size
const CHAT_FILE_GPT41_CONTEXT_WINDOW_TOKENS = 1_047_576;
// Token budgets reserved by the agent (mirrors COMPRESS_MAX_TOKENS and
// MESSAGE_HISTORY_SUMMARY_MAX_TOKENS in the aiserver)
const CHAT_FILE_AGENT_RESPONSE_MAX_TOKENS = 20_000;
const CHAT_FILE_AGENT_SUMMARY_MAX_TOKENS = 1_000;
// Tokens available for file content and user prompt after reserving agent budgets
export const CHAT_FILE_AVAILABLE_TOKENS =
  CHAT_FILE_GPT41_CONTEXT_WINDOW_TOKENS -
  CHAT_FILE_AGENT_RESPONSE_MAX_TOKENS -
  CHAT_FILE_AGENT_SUMMARY_MAX_TOKENS;
// Image token estimation: conservative rate of 100 pixels per token
export const CHAT_FILE_PIXELS_PER_TOKEN = 100;
// Text token estimation: English text tokenises at ~4 bytes/token; 3 is conservatively lower
export const CHAT_FILE_TEXT_BYTES_PER_TOKEN = 3;
// MIME types processed as images (pixel-based token estimation)
export const CHAT_FILE_IMAGE_MIME_TYPES = new Set(["image/jpeg", "image/png"]);

const CHAT_FILE_ALLOWED_MIME_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "text/csv",
] as const;
export const CHAT_FILE_ALLOWED_MIME_TYPE_SET = new Set<string>(
  CHAT_FILE_ALLOWED_MIME_TYPES
);

const CHAT_FILE_ALLOWED_EXTENSIONS = [
  "pdf",
  "jpg",
  "jpeg",
  "png",
  "xls",
  "xlsx",
  "doc",
  "docx",
  "txt",
  "csv",
] as const;
export const CHAT_FILE_ALLOWED_EXTENSION_SET = new Set<string>(
  CHAT_FILE_ALLOWED_EXTENSIONS
);
export const CHAT_FILE_ACCEPTED_TYPES = CHAT_FILE_ALLOWED_EXTENSIONS.map(
  (extension) => `.${extension}`
).join(",");
